module.exports = __webpack_public_path__ + "img/shot_tx19122401.817850cc.jpg";